'use client'

import type { LoginContainerProps } from '@maestro/commerce-blocks/components/login/login.types'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { useLoginModal } from '@maestro/commerce-blocks/components/login/batons/use-login-modal'
import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const Login = dynamic(
  () => import('@maestro/commerce-blocks/components/login/login')
)

export default function LoginModal(props: LoginContainerProps) {
  const { cmsBlock, cmsBlockForgotPassword } = props
  const { addModal } = useModals()
  const t = useTranslations('commerce-blocks')
  const { loginModalKey } = useLoginModal()

  useEffect(() => {
    addModal({
      key: loginModalKey,
      hash: loginModalKey,
      Component: (
        <SlideInBody>
          <Login
            cmsBlock={cmsBlock}
            cmsBlockForgotPassword={cmsBlockForgotPassword}
          />
        </SlideInBody>
      ),
      props: {
        title: t('auth.login.title'),
        customClassName: 'login-modal',
      },
    })
  }, [addModal, cmsBlock, cmsBlockForgotPassword, loginModalKey, t])

  return null
}
